import Vue from 'vue';
import Router from 'vue-router';
import sensors from '../utils/sensors'
import api from './../api'
import routes from './routers';
import store from '../store/index';
import config from '../config/url';
import { Notify } from 'vant'

Vue.use(Router);
const router = new Router({
    mode: 'history',
    routes,
});

let params = {
    url: config.confUrl,
};
let frontendConfig = null

const SHOW_TABBARS = [ 'course', 'learning', 'saccount', 'goodsList',]


router.beforeEach(async (to, from, next) => {
    // console.log("to",to)
    if (to.name === 'idcard' || to.name === 'cepverification' || to.name === 'goodsList' || to.name === 'goodsDetail') {
        store.state.idcardBefore = from.fullPath
    }
    if (to.query.distributionId) store.state.distributionId = to.query.distributionId
    !frontendConfig && await api.usercenter.getConfiguration({ params }).then(res => {
        if (res.data) {
            frontendConfig = res.data.frontendConfig.filter(item => {
                if (item.key === 'home') {
                    return true;
                }
            })
            console.log("配置的首页是",frontendConfig)
            sessionStorage.setItem('theme',res.data.theme)
            sessionStorage.setItem('frontendConfig',JSON.stringify(res.data.frontendConfig))
            if (res.data.pageTitle) {
                document.title = res.data.pageTitle;
                localStorage.setItem('pageTitle', res.data.pageTitle)
            }
        }
    })
    const token = localStorage.getItem('token')
    if(frontendConfig && token){
        if (localStorage.getItem('pageTitle')) {
            document.title = localStorage.getItem('pageTitle');
        }
    }
    
    if(to.meta && !to.meta.login){ //不需要登录
        next()
    }
    else if (to.path === '/goodsDetail' || to.path === '/goodsList') {
        next()
    } else {
        if (token) { //有权限
            next();
        } else { // 无权限
            next('/login')
        }
    }

    if (SHOW_TABBARS.includes(to.name)) {
        store.commit('setTabbar', {
            show: true,
            active: to.name
        });
    } else {
        store.commit('setTabbar', { show: false });
    }
});

router.afterEach(() => {
    window.scrollTo(0, 0);
});


export default router;
